import { useMemo, type CSSProperties } from "react";
import { range, rand, pick } from "../utils/random";
import type { EffectProps } from "./types";

const COLORS = ["#fff8ed", "#ffd966", "#ffb3c1", "#ff85a1", "#fff", "#ffe5ec"];

export function GlitterRain({ count = 110 }: EffectProps = {}) {
  const flecks = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        left: `${rand(0, 100)}vw`,
        size: `${rand(2, 6)}px`,
        color: pick(COLORS),
        fallDuration: `${rand(2.5, 6)}s`,
        delay: `${rand(-6, 0)}s`,
        opacity: rand(0.4, 1),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {flecks.map(f => (
        <span
          key={f.id}
          className="fx-particle fx-glitter"
          style={
            {
              left: f.left,
              top: 0,
              width: f.size,
              height: f.size,
              color: f.color,
              background: f.color,
              opacity: f.opacity,
              animationDuration: f.fallDuration,
              animationDelay: f.delay,
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
